import { createSelector } from 'reselect'
import { selectActiveCrossingDataRefactored } from './selectActiveCrossingDataRefactored'
import { selectActiveModifyBooking } from '../modifyBooking/selectors'

import { getFilteredAccommodations } from './getFilteredAccommodations'

export const selectAvailableKennelsRefactored = createSelector(
  selectActiveCrossingDataRefactored,
  selectActiveModifyBooking,
  (activeCrossings, activeModifyBooking) => {
    if (!activeCrossings) {
      return {}
    }

    const constraints = {
      type: 'include',
      key: 'resourceCode',
      values: ['CDK', 'PTL']
    }

    return getFilteredAccommodations(
      activeCrossings,
      activeModifyBooking,
      constraints
    )
  }
)
